/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
export const EMAIL_VALIDATOR = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PASSWORD_VALIDATOR = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\-_+'"|#^\(\)<>~/\/=;])[A-Za-z\d@$!%*?&\-_+'"|#^\(\)<>~/\/=;]{8,20}$/;
export const NAME_VALIDATOR = /^[a-zA-Z]+([ '-]{0,1}[a-zA-Z]+){0,2}[.]{0,1}$/;
export const PHONE_NUMBER_VALIDATOR = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
export const CREDIT_CARD_NUMBER_VALIDATOR = /^4[0-9]{12}(?:[0-9]{3})?$/;
export const CVC_VALIDATOR = /^[0-9]{3,4}$/;
export const EXPIRY_DATA_VALIDATOR = /^(0[1-9]|1[0-2])\/([0-9]{2})$/;
